import { Box, makeStyles, Grid, Typography } from "@material-ui/core";

import { COLORS } from "../../theme/colors";
import { GraphFooter } from "../../components/parts";
import { DoubleBarChart } from "../../components/charts";
import { defaultItems } from "../../components/parts/graphFooter";
import { NoDataCard } from "../../components/parts/noDataCard";

const useStyles = makeStyles((theme) => ({
  graphContainer: {
    padding: `0 ${theme.spacing(4)}px`,
  },
  graphTitleGroup: {
    margin: "0 auto 20px",
    marginLeft: -20,
  },
  graphTitle: {
    fontWeight: 700,
    marginRight: 5,
    color: COLORS.blue,
  },
  graphName: {
    maxWidth: 164,
    textAlign: "center",
    margin: "0 auto",
  },
  graphItemChart: {
    width: 140,
    height: 140,
    margin: "0 auto",
  },
}));

export const TenancyChart = ({
  chartData,
  bars,
  chartStyle,
  nameStyle,
  graphFooterItems,
  containerStyle,
  showTitleOnCheck,
  checkTitleKeys,
}) => {
  const classes = useStyles();

  return (
    <Box>
      <Grid container style={containerStyle}>
        {chartData.map((item, i) => (
          <Grid item xs className={classes.graphContainer} key={i}>
            {checkTitleKeys?.length &&
            checkTitleKeys.includes(item.key) &&
            item.checkValue &&
            item.onlyZeroValues ? (
              <Grid
                container
                justifyContent="center"
                className={classes.graphTitleGroup}
                wrap="nowrap"
              >
                {showTitleOnCheck ? (
                  <Typography className={classes.graphTitle} style={{ color: item.titleColor }}>
                    {item.title}
                  </Typography>
                ) : null}
                <Typography style={{ color: item.suffixColor }}>{item.suffix}</Typography>
              </Grid>
            ) : !item.onlyZeroValues ? (
              <Grid
                container
                justifyContent="center"
                className={classes.graphTitleGroup}
                wrap="nowrap"
              >
                <Typography className={classes.graphTitle} style={{ color: item.titleColor }}>
                  {item.title}
                </Typography>
                <Typography style={{ color: item.suffixColor }} noWrap>
                  {item.suffix}
                </Typography>
              </Grid>
            ) : null}

            {item.onlyZeroValues ? (
              <Box style={{ minHeigth: "100px" }}>
                <NoDataCard
                  boxStyle={{ padding: 12 }}
                  rootStyle={{ minHeight: "50px" }}
                  gridStyle={{ height: 94 }}
                  withShaDowBox={false}
                />
              </Box>
            ) : (
              <Box className={classes.graphItemChart} style={chartStyle}>
                <DoubleBarChart
                  data={item.chartData}
                  bars={bars ?? item.bars}
                  vertical={false}
                  horizontal={false}
                  hideYAxis={true}
                  xAxisStroke={COLORS.darks[0][10]}
                  xAxisStrokeWidth={2}
                  hideSum
                />
              </Box>
            )}
            <Typography
              variant="h4"
              className={classes.graphName}
              style={{ marginTop: item.onlyZeroValues ? 15 : -20, ...nameStyle }}
            >
              {item.name}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <GraphFooter items={graphFooterItems} />
    </Box>
  );
};

TenancyChart.defaultProps = {
  graphFooterItems: defaultItems,
};
